export default {
	state: {
		userInfo: { // 用户信息窗口
			show: false,
			user: {},
			pos: {
				x: 0,
				y: 0
			}
		},
		fullImage: { // 全屏大图
			show: false,
			url: ""
		}
	},
	mutations: {
		showUserInfoBox(state, user) {
			state.userInfo.show = true;
			state.userInfo.user = user;

		},
		setUserInfoBoxPos(state, pos) {
			let w = document.documentElement.clientWidth;
			let h = document.documentElement.clientHeight;
			const boxWidth = 300; // 弹出框宽度
			const boxHeight = 200; // 弹出框高度
			const offset = 10; // 与头像的间距
			
			// 默认显示在头像右侧
			let x = pos.x + offset;
			let y = pos.y;
			
			// 如果右侧空间不够，显示在左侧
			if (x + boxWidth > w) {
				x = pos.x - boxWidth - offset;
			}
			
			// 如果底部空间不够，向上调整
			if (y + boxHeight > h) {
				y = h - boxHeight - 10;
			}
			
			// 确保不超出顶部边界
			if (y < 10) {
				y = 10;
			}
			
			// 确保不超出左右边界
			if (x < 10) {
				x = 10;
			}
			if (x + boxWidth > w - 10) {
				x = w - boxWidth - 10;
			}
			
			state.userInfo.pos.x = x;
			state.userInfo.pos.y = y;
		},
		closeUserInfoBox(state) {
			state.userInfo.show = false;
		},
		showFullImageBox(state, url) {
			state.fullImage.show = true;
			state.fullImage.url = url;
		},
		closeFullImageBox(state) {
			state.fullImage.show = false;
		}
	}
}